import { config } from '../configs/config';

export const platformSpecific = <T>({ web, native }: { web: T; native: T }) => (config.isNative ? native : web);
